import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';
import { useTranslation } from "react-i18next";
import { Button } from '@mui/material';
import '../styles/ModalDelete.css';

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    bgcolor: 'background.paper',
    boxShadow: 24,
    p: 4,
};


const ModalDelete = ({isOpenDeleteModal, setIsOpenDeleteModal, deleteFunction}) => {

    const handleClose = () => setIsOpenDeleteModal(false);
    const { t } = useTranslation();

    return (
        <div>
            <Modal
                open={isOpenDeleteModal}
                onClose={handleClose}
            >
                <Box sx={style}>
                    <Typography className="modalLabel" id="modal-modal-title" variant="h6" component="h2">{t("confirmDelete")}</Typography>
                    <div className="modalButtons">
                        <Button variant="contained" color="error" onClick={deleteFunction}>{t("delete")}</Button>
                        <Button variant="outlined" color="primary" onClick={() => setIsOpenDeleteModal(false)}>{t("cancel")}</Button>    
                    </div>   
                </Box>
            </Modal>
        </div>
    );
}

export default ModalDelete;